/**
 * スタッフ紹介: タブ切り替え（.js-staff-tabs）
 */
import { updateStaffRecommendCardMatchHeight } from './staff-recommend-card-match.js';

function setActiveTab(tablist, activeTab) {
	let propertyPanelShown = false;
	const tabs = tablist.querySelectorAll('[role="tab"]');
	tabs.forEach((tab) => {
		const on = tab === activeTab;
		tab.classList.toggle('is-active', on);
		tab.setAttribute('aria-selected', on ? 'true' : 'false');
		const panelId = tab.getAttribute('aria-controls');
		if (!panelId) return;
		const panel = document.getElementById(panelId);
		if (panel) panel.hidden = !on;
		if (panelId === 'staff-tab-panel-property' && on) {
			propertyPanelShown = true;
		}
	});
	if (propertyPanelShown) {
		requestAnimationFrame(function () {
			requestAnimationFrame(updateStaffRecommendCardMatchHeight);
		});
	}
}

export function init() {
	const tablists = document.querySelectorAll('.js-staff-tabs');
	tablists.forEach((tablist) => {
		tablist.addEventListener('click', (e) => {
			const tab = e.target.closest('[role="tab"]');
			if (!tab || !tablist.contains(tab)) return;
			e.preventDefault();
			setActiveTab(tablist, tab);
		});
	});

	const tablist = document.querySelector('.js-staff-tabs');
	const section = document.getElementById('staff-tab-section');
	const voiceTriggers = document.querySelectorAll('.js-staff-tab-voice');
	const propertyTriggers = document.querySelectorAll('.js-staff-tab-property');
	if (!tablist || !section || (!voiceTriggers.length && !propertyTriggers.length)) return;

	function activateTabAndScrollToSection(tabEl) {
		if (!tabEl) return;
		setActiveTab(tablist, tabEl);
		section.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	voiceTriggers.forEach((el) => {
		el.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopImmediatePropagation();
			activateTabAndScrollToSection(document.getElementById('staff-tab-voice'));
		});
	});
	propertyTriggers.forEach((el) => {
		el.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopImmediatePropagation();
			activateTabAndScrollToSection(document.getElementById('staff-tab-property'));
		});
	});
}
